module.exports = __webpack_public_path__ + "static/media/diaper-weight.2dab34ca.png";